import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Dices } from "lucide-react";
import { toast } from "sonner";

const diceTypes = [4, 6, 8, 10, 12, 20];

export const DiceRoller = () => {
  const [selectedDice, setSelectedDice] = useState(6);
  const [result, setResult] = useState<number | null>(null);
  const [isRolling, setIsRolling] = useState(false);

  const rollDice = () => {
    setIsRolling(true);
    
    // Animate for a brief moment
    setTimeout(() => {
      const array = new Uint32Array(1);
      crypto.getRandomValues(array);
      const roll = (array[0] % selectedDice) + 1;
      setResult(roll);
      setIsRolling(false);
      toast.success(`Rolled a ${roll}!`);
    }, 300);
  };

  return (
    <Card className="p-6 shadow-[var(--shadow-medium)]">
      <div className="flex items-center gap-2 mb-6">
        <Dices className="w-6 h-6 text-accent" />
        <h2 className="text-2xl font-bold text-foreground">Dice Roller</h2>
      </div>

      <div className="grid grid-cols-3 md:grid-cols-6 gap-2 mb-6">
        {diceTypes.map((dice) => (
          <Button
            key={dice}
            variant={selectedDice === dice ? "default" : "outline"}
            onClick={() => setSelectedDice(dice)}
            className="h-12"
          >
            D{dice}
          </Button>
        ))}
      </div>

      <Button onClick={rollDice} className="w-full mb-4 h-12 text-lg touch-manipulation" disabled={isRolling}>
        Roll D{selectedDice}
      </Button>

      {result !== null && (
        <div className="bg-gradient-to-br from-accent to-accent/80 rounded-lg p-8 text-center">
          <div className={`text-6xl font-bold text-accent-foreground transition-transform ${isRolling ? 'scale-110' : 'scale-100'}`}>
            {result}
          </div>
        </div>
      )}
    </Card>
  );
};
